function portableTextToString(blocks, { blockSeparator = "\n\n" } = {}) {
  return (
    (blocks ?? [])
      .filter((b) => b && b._type === "block")
      .map((block) => {
        // Join all spans within a block (keeps any \n already inside span.text)
        return (block.children ?? [])
          .filter((c) => c && c._type === "span")
          .map((c) => c.text ?? "")
          .join("")
      })
      // Add extra newlines between separate block objects
      .join(blockSeparator)
      .replace(/\u00A0/g, " ")
  ) // normalize NBSP
}

export const parseAutoReplyMessage = (template, name) => {
  if (!template) return ""
  const templateString = portableTextToString(template) || ""
  return templateString.replace("<name>", name)
}